module.exports = __webpack_public_path__ + "img/computer@2x.ec536d88.png";